import { SubNavLayout } from "@/components/SubNavLayout"
import { PATHS, RESOURCES_PATHS } from "@/routing/paths"

import { FormattedMessage } from "react-intl"
import { Navigate, Route, Routes } from "react-router-dom"
import { Documents } from "./tabs/Documents"
import { Help } from "./tabs/Help"
import { MailSign } from "./tabs/MailSign"

export const Resources: React.FC = () => {
  return (
    <SubNavLayout title={<FormattedMessage id="resources" />}>
      <Routes>
        <Route
          index
          element={<Navigate to={`${PATHS.RESOURCES}${RESOURCES_PATHS.DOCUMENTS}`} replace />}
        />
        <Route path={RESOURCES_PATHS.DOCUMENTS} element={<Documents />} />
        <Route path={RESOURCES_PATHS.HELP} element={<Help />} />
        <Route path={RESOURCES_PATHS.MAIL_SIGN} element={<MailSign />} />
      </Routes>
    </SubNavLayout>
  )
}
